import React, { Component } from "react";
import { Statistic, Row, Col, Divider } from "antd";

class PayableDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  render() {
    const { data } = this.props;
    const statistics = data.statistics || {};
    return (
      <Row gutter={16} style={{ marginBottom: "10px" }}>
        {data.isArchived === 1 ? (
          <Col span={9}>
            <Row>
              <Col span={6}>
                <div style={{ display: "flex" }}>
                  <Statistic title="合同款" value={statistics.all} />
                  <Divider
                    type="vertical"
                    style={{ top: "5px", height: "40px" }}
                  />
                </div>
              </Col>
              <Col span={6}>
                <Statistic title="已收款" value={statistics.paid} />
              </Col>
              <Col span={6}>
                <Statistic title="作废款" value={statistics.obsolete} />
              </Col>
              <Col span={6}>
                <Statistic title="已退款" value={statistics.refund} />
              </Col>
            </Row>
          </Col>
        ) : (
          <Col span={14}>
            <Row>
              <Col span={4}>
                <div style={{ display: "flex" }}>
                  <Statistic title="合同款" value={statistics.all} />
                  <Divider
                    type="vertical"
                    style={{ top: "5px", height: "40px" }}
                  />
                </div>
              </Col>
              <Col span={4}>
                <Statistic title="待收款" value={statistics.pending} />
              </Col>
              <Col span={4}>
                <Statistic title="已收款" value={statistics.paid} />
              </Col>
              <Col span={4}>
                <Statistic title="作废款" value={statistics.obsolete} />
              </Col>
              <Col span={4}>
                <Statistic title="应退款" value={statistics.pendingRefund} />
              </Col>
              <Col span={4}>
                <Statistic title="已退款" value={statistics.refund} />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    );
  }
}

export default PayableDetail;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/PayableStatic.js